module.exports = __webpack_public_path__ + "static/img/login_logo.8062d50.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/login_logo.png
// module id = 3Fro
// module chunks = 18